import { render } from "./ImageVerificationActive.vue?vue&type=template&id=756defcf&scoped=true"
import script from "./ImageVerificationActive.vue?vue&type=script&lang=js"
export * from "./ImageVerificationActive.vue?vue&type=script&lang=js"

import "./ImageVerificationActive.vue?vue&type=style&index=0&id=756defcf&scoped=true&lang=css"

import exportComponent from "/var/www/spom.vh/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-756defcf"]])

export default __exports__